import { render } from "./index_view.vue?vue&type=template&id=f1a49ec4"
import script from "./index_view.vue?vue&type=script&lang=js"
export * from "./index_view.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__